import React from "react";
import FullStory from "react-fullstory";
import { hot, setConfig } from "react-hot-loader";
import { Route, Switch } from "react-router-dom";

import config from "config";

import { AuthenticatedRoutes, UnauthenticatedRoutes } from "routes";

import Alert from "components/Alerts";
import ErrorPage from "components/ErrorPage";

import { useAuth } from "scenes/Authentication/components/AuthProvider";

import HublyOauthLinkHandler from "./scenes/Login/components/HublyOauthLinkHandler";

setConfig({
  ignoreSFC: true, // RHL will be __completely__ disabled for SFC
  pureRender: true, // RHL will not change render method
});

function App() {
  const { loading, user } = useAuth();

  if (loading) {
    return null;
  }

  return (
    <React.Fragment>
      <Alert />
      <FullStory
        org={config?.fullStory?.orgId}
        debug={config?.fullStory?.debug}
      />

      <Switch>
        <Route exact path="/error">
          <ErrorPage />
        </Route>

        {user ? <AuthenticatedRoutes /> : <UnauthenticatedRoutes />}
      </Switch>
      <HublyOauthLinkHandler />
    </React.Fragment>
  );
}

export default process.env.NODE_ENV === "development" ? hot(module)(App) : App;
